import useRouter from '@/hooks/useRouter';
import { PAGE_TYPE } from '@/constants';
import _ from 'lodash';

/**
 * 表单页面，分为三种类型
 * 新建页，无默认值
 * 详情页，有默认值
 * 其他页面
 *
 * 新建页路由为 `xxx/create`，详情页路由为 `xxx/detail/:id`
 */
const usePageType = () => {
  const { pathname, query } = useRouter();

  if (pathname.includes('create')) {
    return PAGE_TYPE.CREATE;
  }

  if (pathname.includes('detail')) {
    return PAGE_TYPE.DETAIL;
  }

  return PAGE_TYPE.OTHER;
};

export default usePageType;
